module.exports = "/packs/period1-6d312227422ee995ccaa9960aeba2142.png";